import { DefineStepFunction } from 'jest-cucumber'
import { CardString } from 'pokersolver'

import { Player } from '../../model/Player'
import { Table } from '../../model/Table'

/**
 * Sets up a new table and adds the requested number of players
 * with a buy in of 10000
 *
 * @param given given clause
 * @param table table to update
 */
const givenXplayersAtATable = (given: DefineStepFunction, table: Table) => {
  given(/^(\d+) players at a table$/, (playerCountStr: string) => {
    const playerCount = parseInt(playerCountStr, 10)
    addPlayersToTableWithBuyIn(playerCount, 10000, table)
  })
}
/**
 * Sets up a new table and adds the requested number of players
 * with the specified buy in of chips
 *
 * @param given given clause
 * @param table table to update
 */
const givenXplayersAtATableWithBuyInOfYChips = (given: DefineStepFunction, table: Table) => {
  given(/^(\d+) players at a table with buy in of (\d+) chips$/, (playerCountStr: string, chips: string) => {
    const playerCount = parseInt(playerCountStr, 10)
    const chipBuyIn = parseInt(chips, 10)
    addPlayersToTableWithBuyIn(playerCount, chipBuyIn, table)
  })
}
/**
 * Sets up a new table and adds players with specified chips
 *
 * @param playerCount players to add
 * @param buyInChips initial chips to set for buy in
 * @param table table to update
 */
const addPlayersToTableWithBuyIn = (playerCount: number, buyInChips: number, table: Table) => {
  for (let i = playerCount - 1; i >= 0; i--) {
    table.addPlayer({
      name: `player_${i}`,
      chips: buyInChips,
      userId: `${i}`
    })
  }
}
/**
 * Deals a new hand at the specified table
 *
 * @param and and clause
 * @param table table to update
 */
const andAHandIsDealt = (and: DefineStepFunction, table: Table) => {
  and('a hand is dealt', () => {
    table.newHand()
  })
}
/**
 * Sets a players cards explicitly using the players name:
 * `player_0 has cards Ah and 9s'
 *
 * @param and and clause
 * @param table table to update
 */
const andPlayerXHasCardsY = (and: DefineStepFunction, table: Table) => {
  and(/^(.*) has (.*) and (.*)$/, (playerName: string, cardOne: CardString, cardTwo: CardString) => {
    const player: Player | undefined = table.getPlayerByName(playerName)
    if (!player) {
      throw new Error(`Player not found with name ${playerName}`)
    }
    player.returnCards()
    player.getCards([cardOne, cardTwo])

    removeCardsFromDeck(table, [cardOne, cardTwo])
  })
}

const andDeckWillDeal = (and: DefineStepFunction, table: Table) => {
  and(/^deck will deal (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*), (.*)$/, (...cards: CardString[]) => {
    stackTheDeck(table, cards)
  })
}

const stackTheDeck = (table: Table, cards: CardString[]) => {
  removeCardsFromDeck(table, cards)
  cards.map((card) => {
    if (card) {
      table.board.deck.cards.unshift(card)
    }
  })
}

const removeCardsFromDeck = (table: Table, cards: CardString[]) => {
  cards.map((card) => {
    if (table.board.deck.cards.includes(card)) {
      const idx = table.board.deck.cards.indexOf(card)
      table.board.deck.cards.splice(idx, 1)
    }
  })
}

export {
  givenXplayersAtATable,
  givenXplayersAtATableWithBuyInOfYChips,
  andAHandIsDealt,
  andPlayerXHasCardsY,
  andDeckWillDeal,
  stackTheDeck
}
